import { render, staticRenderFns } from "./Conversation.vue?vue&type=template&id=6fbf5b76&scoped=true&"
import script from "./Conversation.vue?vue&type=script&lang=js&"
export * from "./Conversation.vue?vue&type=script&lang=js&"
import style0 from "./Conversation.vue?vue&type=style&index=0&id=6fbf5b76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbf5b76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VForm,VIcon,VImg,VProgressLinear,VTextarea})
